import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useAuth } from '../contexts/authContext';
import { capabilityApiConnect } from '../lib/api/capabilityApi.connect';
/**
 * Hook for the Capability Matrix page.
 * Queries gap analysis results and provides a mutation to trigger matching.
 */ export function useCapabilityMatrix(projectId) {
    const { user } = useAuth();
    const queryClient = useQueryClient();
    const companyId = user?.tenant_id ?? '';
    const gapAnalysisQuery = useQuery({
        queryKey: [
            'capabilityGapAnalysis',
            projectId,
            companyId
        ],
        queryFn: ()=>capabilityApiConnect.getCapabilityGapAnalysis(projectId, companyId),
        enabled: !!projectId && !!companyId,
        staleTime: 60000
    });
    const runMatchMutation = useMutation({
        mutationFn: ()=>capabilityApiConnect.runCapabilityMatch(projectId, companyId),
        onSuccess: (result)=>{
            toast.success(`Matched ${result.requirementsMatched} requirements` + (result.requirementsFailed > 0 ? ` (${result.requirementsFailed} failed)` : ''));
            queryClient.invalidateQueries({
                queryKey: [
                    'capabilityGapAnalysis',
                    projectId,
                    companyId
                ]
            });
        },
        onError: (err)=>{
            const message = err instanceof Error ? err.message : 'Failed to run capability match';
            toast.error(message);
        }
    });
    return {
        gapAnalysisQuery,
        runMatchMutation,
        isReady: !!projectId && !!companyId
    };
}
